/* eslint-disable-next-line */
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const isValidEmail = (email) => email && emailRegex.test(email);

/* eslint-disable-next-line */
const phoneNumberRegex = /^\+\d[\d\-]{4,14}/

export const isValidPhoneNumber = (phoneNumber) => phoneNumberRegex.test(phoneNumber);

export const checkErrors = ({ errorMessage, errors }) => {
  const errorsExist = Object.values(errors).some((err) => !!err);
  if (errorMessage || errorsExist) {
    const error = {
      message: errorMessage || 'Please fill out required fields',
      errors,
    };
    throw error;
  }
};



// WEBPACK FOOTER //
// ./services/validationService.js